import { render, staticRenderFns } from "./GerarAquisicaoLista.vue?vue&type=template&id=4025a7f4&"
import script from "./GerarAquisicaoLista.vue?vue&type=script&lang=js&"
export * from "./GerarAquisicaoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports